/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const RULE_TYPES = [
  { id: 'weekend',         label: 'Nuits du weekend',      desc: 'Vendredi et samedi soir',         emoji: '🎉', color: '#534AB7' },
  { id: 'season',          label: 'Saison haute / basse',  desc: 'Période de dates personnalisée',  emoji: '☀️', color: '#E8A23D' },
  { id: 'school_holidays', label: 'Vacances scolaires',    desc: 'Période de dates précises',       emoji: '🏖', color: '#1A73E8' },
  { id: 'long_stay',       label: 'Séjour longue durée',   desc: 'Réduction pour X nuits ou plus',  emoji: '📅', color: '#1D9E75' },
];

const ADJ_PRESETS = [
  { label: '+10%', value: 10,  type: 'percent' },
  { label: '+20%', value: 20,  type: 'percent' },
  { label: '+30%', value: 30,  type: 'percent' },
  { label: '+50%', value: 50,  type: 'percent' },
  { label: '-10%', value: -10, type: 'percent' },
  { label: '-15%', value: -15, type: 'percent' },
  { label: '-20%', value: -20, type: 'percent' },
];

function RuleForm({ rule, onSave, onCancel, listingId, hostId }) {
  const [form, setForm] = useState(rule || {
    rule_type: 'weekend',
    label: '',
    date_start: '',
    date_end: '',
    adjustment_type: 'percent',
    adjustment_value: 20,
    min_nights: 7,
  });
  const [saving, setSaving] = useState(false);

  const selectedType = RULE_TYPES.find(t => t.id === form.rule_type);

  const handleSave = async () => {
    setSaving(true);
    console.log('payload:', { listingId, hostId });
    const payload = {
      listing_id: listingId,
      host_id: hostId,
      rule_type: form.rule_type,
      label: form.label || selectedType?.label,
      adjustment_type: form.adjustment_type,
      adjustment_value: parseFloat(form.adjustment_value),
      date_start: form.date_start || null,
      date_end: form.date_end || null,
      min_nights: form.rule_type === 'long_stay' ? parseInt(form.min_nights) : null,
    };
    if (rule?.id) {
      await supabase.from('pricing_rules').update(payload).eq('id', rule.id);
    } else {
      await supabase.from('pricing_rules').insert(payload);
    }
    setSaving(false);
    onSave();
  };

  return (
    <div style={{ background: '#fff', border: '2px solid #1D9E75', borderRadius: 14, padding: 20 }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#0F1A16', marginBottom: 16 }}>
        {rule?.id ? 'Modifier la règle' : 'Nouvelle règle tarifaire'}
      </div>

      {/* Type */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 8, fontWeight: 500 }}>Type de règle</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 }}>
          {RULE_TYPES.map(t => (
            <button key={t.id} onClick={() => setForm(f => ({ ...f, rule_type: t.id, label: t.label }))}
              style={{ padding: '10px 12px', borderRadius: 10, border: `1.5px solid ${form.rule_type === t.id ? t.color : '#EAECEF'}`, background: form.rule_type === t.id ? `${t.color}12` : '#fff', cursor: 'pointer', textAlign: 'left', fontFamily: 'var(--sans)' }}>
              <div style={{ fontSize: 16, marginBottom: 3 }}>{t.emoji}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: form.rule_type === t.id ? t.color : '#0F1A16' }}>{t.label}</div>
              <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>{t.desc}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Label personnalisé */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6, fontWeight: 500 }}>Nom de la règle (optionnel)</div>
        <input value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))}
          placeholder={selectedType?.label}
          style={{ width: '100%', padding: '8px 12px', border: '1px solid #EAECEF', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
      </div>

      {/* Dates pour saison et vacances */}
      {(form.rule_type === 'season' || form.rule_type === 'school_holidays') && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
          <div>
            <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6, fontWeight: 500 }}>Date de début</div>
            <input type="date" value={form.date_start} onChange={e => setForm(f => ({ ...f, date_start: e.target.value }))}
              style={{ width: '100%', padding: '8px 12px', border: '1px solid #EAECEF', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6, fontWeight: 500 }}>Date de fin</div>
            <input type="date" value={form.date_end} onChange={e => setForm(f => ({ ...f, date_end: e.target.value }))}
              style={{ width: '100%', padding: '8px 12px', border: '1px solid #EAECEF', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          {form.rule_type === 'season' && (
            <div style={{ gridColumn: '1 / -1', fontSize: 11, color: '#9CA3AF', background: '#F9FAFB', padding: '8px 10px', borderRadius: 6 }}>
              💡 Pour une règle annuelle (ex: chaque été), les années seront ignorées — seuls les mois et jours comptent.
            </div>
          )}
        </div>
      )}

      {/* Min nuits pour long stay */}
      {form.rule_type === 'long_stay' && (
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6, fontWeight: 500 }}>Nombre de nuits minimum</div>
          <div style={{ display: 'flex', gap: 8 }}>
            {[7, 10, 14, 21, 28].map(n => (
              <button key={n} onClick={() => setForm(f => ({ ...f, min_nights: n }))}
                style={{ padding: '6px 14px', borderRadius: 20, border: `1px solid ${form.min_nights === n ? '#1D9E75' : '#EAECEF'}`, background: form.min_nights === n ? '#E8F5F0' : '#fff', color: form.min_nights === n ? '#0F6E56' : '#6B7280', fontSize: 13, cursor: 'pointer', fontFamily: 'var(--sans)', fontWeight: form.min_nights === n ? 600 : 400 }}>
                {n} nuits
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Ajustement */}
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 8, fontWeight: 500 }}>
          {form.rule_type === 'long_stay' ? 'Réduction' : 'Ajustement de prix'}
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
          {ADJ_PRESETS.filter(p => form.rule_type === 'long_stay' ? p.value < 0 : true).map(p => (
            <button key={p.label} onClick={() => setForm(f => ({ ...f, adjustment_value: p.value, adjustment_type: p.type }))}
              style={{ padding: '5px 12px', borderRadius: 20, border: `1px solid ${form.adjustment_value === p.value ? (p.value > 0 ? '#E8A23D' : '#1D9E75') : '#EAECEF'}`, background: form.adjustment_value === p.value ? (p.value > 0 ? '#FDF8EE' : '#E8F5F0') : '#fff', color: form.adjustment_value === p.value ? (p.value > 0 ? '#C4784A' : '#0F6E56') : '#6B7280', fontSize: 12, cursor: 'pointer', fontFamily: 'var(--sans)', fontWeight: form.adjustment_value === p.value ? 600 : 400 }}>
              {p.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input type="number" value={form.adjustment_value} onChange={e => setForm(f => ({ ...f, adjustment_value: parseFloat(e.target.value) || 0 }))}
            style={{ width: 80, padding: '8px 12px', border: '1px solid #EAECEF', borderRadius: 8, fontSize: 14, fontFamily: 'var(--sans)', outline: 'none', textAlign: 'center', fontWeight: 600 }} />
          <select value={form.adjustment_type} onChange={e => setForm(f => ({ ...f, adjustment_type: e.target.value }))}
            style={{ padding: '8px 12px', border: '1px solid #EAECEF', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none' }}>
            <option value="percent">% du prix de base</option>
            <option value="fixed">€ fixe par nuit</option>
          </select>
          <div style={{ fontSize: 13, color: '#6B7280' }}>
            {form.adjustment_value > 0 ? '📈 Hausse' : '📉 Réduction'}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={handleSave} disabled={saving}
          style={{ flex: 1, padding: '10px', background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
          {saving ? 'Enregistrement...' : '✓ Enregistrer la règle'}
        </button>
        <button onClick={onCancel}
          style={{ padding: '10px 20px', background: 'transparent', border: '1px solid #EAECEF', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontFamily: 'var(--sans)', color: '#6B7280' }}>
          Annuler
        </button>
      </div>
    </div>
  );
}

export default function PricingManager({ listing, hostId, priceNight }) {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingRule, setEditingRule] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [previewStart, setPreviewStart] = useState('');
  const [previewEnd, setPreviewEnd] = useState('');

  useEffect(() => { loadRules(); }, [listing?.id]);

  const loadRules = async () => {
    if (!listing?.id) return;
    setLoading(true);
    const { data } = await supabase.from('pricing_rules').select('*').eq('listing_id', listing.id).order('created_at');
    setRules(data || []);
    setLoading(false);
  };

  const deleteRule = async (id) => {
    setDeleting(id);
    await supabase.from('pricing_rules').delete().eq('id', id);
    setRules(prev => prev.filter(r => r.id !== id));
    setDeleting(null);
  };

  const previewResult = React.useMemo(() => {
    if (!previewStart || !previewEnd || !priceNight) return null;
    const start = new Date(previewStart + 'T12:00:00');
    const end   = new Date(previewEnd   + 'T12:00:00');
    const nights = Math.round((end - start) / 86400000);
    if (nights <= 0) return null;

    const nightDates = [];
    for (let i = 0; i < nights; i++) {
      const d = new Date(start);
      d.setDate(d.getDate() + i);
      nightDates.push(d);
    }

    let total = 0;
    const nightBreakdown = nightDates.map(date => {
      const dateStr = date.toISOString().split('T')[0];
      const dow = date.getDay();
      const isWeekend = dow === 5 || dow === 6;
      const month = date.getMonth() + 1;
      const day = date.getDate();
      let price = priceNight;
      let appliedRules = [];

      rules.forEach(rule => {
        let applies = false;
        if (rule.rule_type === 'weekend' && isWeekend) {
          applies = true;
        } else if ((rule.rule_type === 'season' || rule.rule_type === 'school_holidays') && rule.date_start && rule.date_end) {
          if (rule.rule_type === 'season') {
            const md = `${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
            const smd = rule.date_start.slice(5);
            const emd = rule.date_end.slice(5);
            applies = smd <= emd ? (md >= smd && md <= emd) : (md >= smd || md <= emd);
          } else {
            applies = dateStr >= rule.date_start && dateStr <= rule.date_end;
          }
        }
        if (applies) {
          const adj = rule.adjustment_type === 'percent' ? price * (rule.adjustment_value / 100) : rule.adjustment_value;
          price += adj;
          appliedRules.push(rule.label || rule.rule_type);
        }
      });

      total += Math.max(price, 1);
      return { dateStr, price: Math.round(Math.max(price, 1)), appliedRules };
    });

    const ls = rules.find(r => r.rule_type === 'long_stay');
    if (ls && nights >= (ls.min_nights || 7)) {
      const disc = ls.adjustment_type === 'percent'
        ? total * (Math.abs(ls.adjustment_value) / 100)
        : Math.abs(ls.adjustment_value) * nights;
      total -= disc;
    }

    return { total: Math.round(total), nights, perNight: Math.round(total / nights), breakdown: nightBreakdown };
  }, [previewStart, previewEnd, rules, priceNight]);

  const typeInfo = (ruleType) => RULE_TYPES.find(t => t.id === ruleType);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* Bannière bien — toujours visible */}
      <div style={{ background: '#F0FDF9', border: '1px solid #A7E3CD', borderRadius: 10, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
        {listing?.photos?.[0]
          ? <img src={listing.photos[0]} alt="" style={{ width:40, height:40, objectFit:'cover', borderRadius:8, flexShrink:0 }}/>
          : <div style={{ width:40, height:40, borderRadius:8, background:'#E8F5F0', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1D9E75" strokeWidth="1.5"><path d="M3 21V9l9-6 9 6v12"/></svg></div>
        }
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#0F1A16' }}>{listing?.title || 'Mon bien'}</div>
          <div style={{ fontSize: 12, color: '#0F6E56' }}>{listing?.city} · Prix de base : <strong>{priceNight}€/nuit</strong></div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 600, color: '#0F1A16' }}>Règles tarifaires</div>
          <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>Ajustements automatiques selon les périodes</div>
        </div>
        {!showForm && (
          <button onClick={() => { setShowForm(true); setEditingRule(null); }}
            style={{ padding: '9px 18px', background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 20, fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
            + Ajouter une règle
          </button>
        )}
      </div>

      {showForm && (
        <RuleForm
          rule={editingRule}
          listingId={listing?.id}
          hostId={hostId}
          onSave={() => { setShowForm(false); setEditingRule(null); loadRules(); }}
          onCancel={() => { setShowForm(false); setEditingRule(null); }}
        />
      )}

      {loading ? (
        <div style={{ padding: '2rem', textAlign: 'center', fontSize: 13, color: '#9CA3AF' }}>Chargement...</div>
      ) : rules.length === 0 ? (
        <div style={{ background: '#F9FAFB', border: '2px dashed #EAECEF', borderRadius: 14, padding: '2rem', textAlign: 'center' }}>
          <div style={{ fontSize: 24, marginBottom: 8 }}>💰</div>
          <div style={{ fontSize: 14, fontWeight: 500, color: '#0F1A16', marginBottom: 4 }}>Aucune règle tarifaire</div>
          <div style={{ fontSize: 13, color: '#9CA3AF' }}>Ajoutez des règles pour ajuster vos prix automatiquement selon les périodes.</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {rules.map(rule => {
            const ti = typeInfo(rule.rule_type);
            const isPos = rule.adjustment_value > 0;
            return (
              <div key={rule.id} style={{ background: '#fff', border: '1px solid #EAECEF', borderRadius: 12, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, borderLeft: `4px solid ${ti?.color || '#EAECEF'}` }}>
                <div style={{ fontSize: 20, flexShrink: 0 }}>{ti?.emoji}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0F1A16' }}>{rule.label || ti?.label}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>
                    {rule.rule_type === 'weekend' && 'Vendredi & samedi soir'}
                    {(rule.rule_type === 'season' || rule.rule_type === 'school_holidays') && rule.date_start && rule.date_end &&
                      `${new Date(rule.date_start + 'T12:00:00').toLocaleDateString('fr-FR', {day:'numeric',month:'short'})} → ${new Date(rule.date_end + 'T12:00:00').toLocaleDateString('fr-FR', {day:'numeric',month:'short'})}`
                    }
                    {rule.rule_type === 'long_stay' && `${rule.min_nights || 7} nuits minimum`}
                  </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: isPos ? '#C4784A' : '#0F6E56' }}>
                    {isPos ? '+' : ''}{rule.adjustment_value}{rule.adjustment_type === 'percent' ? '%' : '€'}
                  </div>
                  <div style={{ fontSize: 11, color: '#9CA3AF' }}>{isPos ? 'majoration' : 'réduction'}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button onClick={() => { setEditingRule(rule); setShowForm(true); }}
                    style={{ padding: '5px 10px', background: '#F3F4F6', border: 'none', borderRadius: 8, fontSize: 12, cursor: 'pointer', fontFamily: 'var(--sans)', color: '#374151' }}>
                    ✏️
                  </button>
                  <button onClick={() => deleteRule(rule.id)} disabled={deleting === rule.id}
                    style={{ padding: '5px 10px', background: '#FCEBEB', border: 'none', borderRadius: 8, fontSize: 12, cursor: 'pointer', fontFamily: 'var(--sans)', color: '#A32D2D' }}>
                    {deleting === rule.id ? '...' : '✕'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {rules.length > 0 && (
        <div style={{ background: '#F0FDF9', border: '1px solid #A7E3CD', borderRadius: 14, padding: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#0F1A16', marginBottom: 14 }}>🧮 Simulateur de prix</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6 }}>Arrivée</div>
              <input type="date" value={previewStart} onChange={e => setPreviewStart(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #A7E3CD', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box', background: '#fff' }} />
            </div>
            <div>
              <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6 }}>Départ</div>
              <input type="date" value={previewEnd} onChange={e => setPreviewEnd(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #A7E3CD', borderRadius: 8, fontSize: 13, fontFamily: 'var(--sans)', outline: 'none', boxSizing: 'border-box', background: '#fff' }} />
            </div>
          </div>
          {previewResult && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: '#fff', borderRadius: 10, marginBottom: 8, border: '1px solid #A7E3CD' }}>
                <div>
                  <div style={{ fontSize: 13, color: '#6B7280' }}>{previewResult.nights} nuit{previewResult.nights > 1 ? 's' : ''} · {previewResult.perNight}€/nuit moy.</div>
                  <div style={{ fontSize: 11, color: '#9CA3AF' }}>Prix de base sans règles : {priceNight * previewResult.nights}€</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: '#0F1A16' }}>{previewResult.total}€</div>
                  <div style={{ fontSize: 11, color: previewResult.total > priceNight * previewResult.nights ? '#C4784A' : '#0F6E56', fontWeight: 500 }}>
                    {previewResult.total > priceNight * previewResult.nights
                      ? `+${previewResult.total - priceNight * previewResult.nights}€`
                      : `-${priceNight * previewResult.nights - previewResult.total}€`} vs prix de base
                  </div>
                </div>
              </div>
              <div style={{ maxHeight: 160, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
                {previewResult.breakdown.map((n, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 10px', background: '#fff', borderRadius: 6, fontSize: 12, border: '1px solid #E8F5F0' }}>
                    <div style={{ color: '#374151' }}>
                      {new Date(n.dateStr + 'T12:00:00').toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })}
                      {n.appliedRules.length > 0 && <span style={{ marginLeft: 6, color: '#C4784A', fontSize: 11 }}>({n.appliedRules.join(', ')})</span>}
                    </div>
                    <div style={{ fontWeight: 600, color: n.price !== priceNight ? '#C4784A' : '#374151' }}>{n.price}€</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
